module.exports = __webpack_public_path__ + "fonts/roboto-v30-latin-700.e9f5aaf5.woff2";